import { Component } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import soundURL from './merry_christmas.mp3';
import sledSound from '../../../../../static/assets/easter-eggs/christmas/santa_sled.wav';
import treeImage from '../../../../../static/assets/easter-eggs/christmas/christmas_tree.svg';
import santaImage from '../../../../../static/assets/easter-eggs/christmas/santa.svg';

import './christmas-easter-egg.css';

class ChristmasEasterEgg extends Component {
  constructor(props) {
    super(props);

    this.state = {
      can_click_tree: true,
      showing_santa: false,
    };
  }

  hideSanta() {
    this.setState({ showing_santa: false, can_click_tree: true });
  }

  playSantaSound() {
    const audio = new Audio();
    audio.src = soundURL;
    audio.play();

    const sledAudio = new Audio();
    sledAudio.src = sledSound;
    sledAudio.play();
  }

  onTreeClick() {
    const { can_click_tree } = this.state;

    if (!can_click_tree) {
      return;
    }

    datadogRum.addAction('christmasEasterEggClick', {});

    this.setState({ can_click_tree: false, showing_santa: true });
    this.playSantaSound();
    setTimeout(this.hideSanta.bind(this), 4100);
  }

  render() {
    const { showing_santa } = this.state;

    return (
      <div>
        <img
          title="Merry Christmas!"
          alt="christmas_tree"
          className="christmas_tree"
          onClick={this.onTreeClick.bind(this)}
          src={treeImage}
        ></img>

        {showing_santa && (
          <div className="santa fly">
            <img alt="santa_sleigh" src={santaImage}></img>
          </div>
        )}
      </div>
    );
  }
}

export default ChristmasEasterEgg;
